import React from "react";

import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

import RoomNoFloorAssignListTable from "./Components/RoomNoFloorAssignListTable";

const RoomNoFloorAssignList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>
            Room Floor Assignment List
          </HeadingOne>
        </>
      }
    >
      <div className="col-12">
        <RoomNoFloorAssignListTable />
      </div>
    </PageBody>
  );
};

export default RoomNoFloorAssignList;